import { render } from "./ChampionCard.vue?vue&type=template&id=7da998aa&scoped=true"
import script from "./ChampionCard.vue?vue&type=script&lang=js"
export * from "./ChampionCard.vue?vue&type=script&lang=js"

import "./ChampionCard.vue?vue&type=style&index=0&id=7da998aa&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da998aa"]])

export default __exports__